import { LanguageType } from '@webclient/shared-types/translation';

import de from '@uppy/locales/lib/de_DE';
import en from '@uppy/locales/lib/en_US';
import es from '@uppy/locales/lib/es_ES';
import fr from '@uppy/locales/lib/fr_FR';
import id from '@uppy/locales/lib/id_ID';
import pt from '@uppy/locales/lib/pt_PT';

export default function getLocale(lang: LanguageType) {
  switch (lang) {
    case 'de':
      return de;
    case 'en':
      return en;
    case 'es':
      return es;
    case 'fr':
      return fr;
    case 'id':
      return id;
    case 'pt':
      return pt;
    default:
      lang satisfies never;
  }
}
